import React, { useState, useEffect, useRef  } from 'react';
import { Icon } from '@fluentui/react/lib/Icon';
import dompurify from 'dompurify';
import { v4 as uniqueIdGenerator } from 'uuid';
import Dropdown from '../Dropdown';
import $ from 'jquery';
import { toast } from 'react-toastify';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import ExitCriteriaContribution from './ExitCriteriaContribution';

const EntryCriteriaContribution = ({
	contributorsData,
	entryCriteriaButtonClicked,
	setEntryCriteriaButtonClicked,
	ckEditorUserMap,
	CkEditorCurrentUser,
	entryCriteriaSuggestions,
	setEntryCriteriaSuggestions,
	entryCriteriaWithSuggestions,
	setEntryCriteriaWithSuggestions,
	reviewedEntryCriteriaSuggestions,
	setReviewedEntryCriteriaSuggestions,
	reviewerEntryCriteriaSuggestions,
	source,
	entryCriteriaData,
	setEntryCriteriaData,
	currentTab,
	setCurrentTab,
	entryContributionReorder,
	setEntryContributionReorder,
	setInputContributionReorder,
	inputContributionReorder,
	setInputCriteriaReorderArray,
	setEntryCriteriaReorderArray,
	entryCriteriaReorderArray,
	inputCriteriaReorderArray,
	setReviewedReorderedEntrySuggestions,
    reviewedReorderedEntrySuggestions,
	reviewedReorderedInputSuggestions,
	setReviewedReorderedInputSuggestions,
	initialEntryIdBeforeReorder,
	setInitialEntryIdBeforeReorder,
	disableEntryDrag,
	setDisableEntryDrag,
	disableInputDrag,
	setDisableInputDrag,
	ckEditorCurrentEntryReorderUsername,
    setCkEditorCurrentEntryReorderUsername,
    ckEditorCurrentEntryReorderUserImage,
    setCkEditorCurrentEntryReorderUserImage,
	ckEditorCurrentInputReorderUserImage,
	setCkEditorCurrentInputReorderUserImage,
	ckEditorCurrentInputReorderUsername,
	setCkEditorCurrentInputReorderUsername,
	user,
	setIsReviewerEntryReordered,
	setIsReviewerInputReordered,
	setIsApproverEntryReordered,
	setIsApproverInputReordered,
	setReorderContributionCount,
	setAddedEntrySequence,
	setIsOrderChanged,
	disableControls
}) => {

	const pageType = ['review', 'approve'];
	const htmlSanitizer = dompurify.sanitize;
	const defaultCriteriType = {
		id: 1,
		name: 'Text',
	};
	const defaultCriteriaTypeValue = {
		2: 'Numeric',
		1: 'Text',
	};
	const dropdownValue = [
		{ id: 1, name: 'Text', type: 'option' },
		{ id: 2, name: 'Numeric', type: 'option' },
	];
	const inputRefs = useRef({});
	const [currentEntryTab, setCurrentEntryTab] = useState('tab-entry');
	const [isHideInputBox, setIsHideInputBox]=useState(true);
	const [dropdownValues, setDropdownValues] = useState({});
	const [newItemDescription, setNewItemDescription] = useState("")
	const [criteriaName, setCriteriaName] = useState('');
	const [criteriaDescription, setCriteriaDescription] = useState('');
	const [criteriaType, setCriteriaType] = useState(defaultCriteriType);
	const [error, setError] = useState(false);
	const [editMode, setEditMode] = useState(false);
	const [updateId, setUpdateId] = useState(0);
	const [inputEditMode, setInputEditMode] = useState(false);
	const [inputUpdateId, setInputUpdateId] = useState(0);

	const [entryCriteriaList, setEntryCriteriaList] = useState([
		...contributorsData.entryCriteriaList.filter(
			(item) => item.criteriaTypeName === 'Entry Criteria'
		),
	]);
	const [inputList, setInputList] = useState([
		...contributorsData.entryCriteriaList.filter(
			(item) => item.criteriaTypeName !== 'Entry Criteria'
		),
	]);
	
	const [inputDescription, setInputDescription] = useState('');
	const [toolsSidebarHeight, setToolsSidebarHeight] = useState('50px');
	const [sidebarCard, setSidebarCard] = useState([]);
	const [userImgWithReorder, setUserImgWithReorder] = useState(null)
	const [userNameWithReorder, setUserNameWithReorder] = useState(null)
	const [entryListwithInsert,  setEntryListwithInsert] = useState([...contributorsData.entryCriteriaList.filter(
		(item) => item.criteriaTypeName === 'Entry Criteria'
	),
]); 
const [inputListwithInsert,  setInputListwithInsert] = useState([...contributorsData.entryCriteriaList.filter(
	(item) => item.criteriaTypeName === 'Input'
),
]);
    const [initialEntryCriteriaBeforeReorder, setInitialEntryCriteriaBeforeReorder]=useState([...initialEntryIdBeforeReorder.filter(
		(item)=> JSON.parse(item).criteriaTypeName === 'Entry Criteria'
	)])
	const [initialInputCriteriaBeforeReorder, setInitialInputCriteriaBeforeReorder] = useState([...initialEntryIdBeforeReorder.filter(
		(item)=> JSON.parse(item).criteriaTypeName === 'Input')])

	const updateEntryCriteria = () => {
		if (criteriaType.id !== 0 && criteriaDescription !== '' && criteriaDescription.trim().length !== 0) {
			if (editMode) {
				if (entryCriteriaList.some((item) => item.id === updateId)) {
					const updatedDtails = entryCriteriaWithSuggestions.map((item) =>
						JSON.parse(item).id === updateId
							? JSON.stringify({
								...JSON.parse(item),
								suggestionType: 'updation',
								suggestionId: uniqueIdGenerator(),
								authorId: CkEditorCurrentUser,
								createdAt: new Date(),
								name: criteriaDescription,
								valueType: criteriaType.name === 'Text' ? 1 : 2,
							})
							: item
					);
					setEntryCriteriaWithSuggestions([...updatedDtails]);

					if (
						!entryCriteriaSuggestions.some(
							(item) => JSON.parse(item).id === updateId
						)
					) {
						const entryCriteria = entryCriteriaList
							.filter((item) => item.id === updateId)
							.map((value) => {
								return JSON.stringify({
									...value,
									suggestionType: 'updation',
									suggestionId: uniqueIdGenerator(),
									authorId: CkEditorCurrentUser,
									createdAt: new Date(),
									name: criteriaDescription,
									valueType: criteriaType.name === 'Text' ? 1 : 2,
								});
							});
						setEntryCriteriaSuggestions((prevState) => [
							...prevState,
							...entryCriteria,
						]);
					} else {
						const updatedSuggestions = entryCriteriaSuggestions.map((item) =>
							JSON.parse(item).id === updateId
								? JSON.stringify({
									...JSON.parse(item),
									suggestionType: 'updation',
									suggestionId: uniqueIdGenerator(),
									authorId: CkEditorCurrentUser,
									createdAt: new Date(),
									name: criteriaDescription,

									valueType: criteriaType.name === 'Text' ? 1 : 2,
								})
								: item
						);
						setEntryCriteriaSuggestions([...updatedSuggestions]);
					}
				} else {
					const updatedDtails = entryCriteriaWithSuggestions.map((item) =>
						JSON.parse(item).id === updateId
							? JSON.stringify({
								...JSON.parse(item),
								authorId: CkEditorCurrentUser,
								createdAt: new Date(),
								name: criteriaDescription,
								valueType: criteriaType.name === 'Text' ? 1 : 2,
							})
							: item
					);
					const updateSuggestions = entryCriteriaSuggestions.map((item) =>
						JSON.parse(item).id === updateId
							? JSON.stringify({
								...JSON.parse(item),
								authorId: CkEditorCurrentUser,
								createdAt: new Date(),
								name: criteriaDescription,
								valueType: criteriaType.name === 'Text' ? 1 : 2,
							})
							: item
					);
					setEntryCriteriaSuggestions([...updateSuggestions]);
					setEntryCriteriaWithSuggestions([...updatedDtails]);
				}
				setEditMode(false);
				setCriteriaDescription('');
				setCriteriaType(defaultCriteriType);
				setUpdateId(0);
				setCriteriaName('');

				setError(false);
			} else {
				const entryCriteria = {
					id: uniqueIdGenerator(),
					suggestionId: uniqueIdGenerator(),
					name: criteriaDescription,
					criteriaType: 'Entry',
					valueType: criteriaType.name === 'Text' ? 1 : 2,
					status: 'new',
					criteriaTypeID: 1,
					criteriaTypeName: 'Entry Criteria',
					suggestionType: 'insertion',
					authorId: CkEditorCurrentUser,
					createdAt: new Date(),
					sequence: entryCriteriaWithSuggestions.filter(e=>JSON.parse(e).criteriaTypeID === 1).length + 1
				};
				const entryCriteriaJson = JSON.stringify(entryCriteria);
				setAddedEntrySequence(prev=>[...prev, {id:JSON.parse(entryCriteriaJson).id,
					sequence:JSON.parse(entryCriteriaJson).sequence,criteriaTypeID:JSON.parse(entryCriteriaJson).criteriaTypeID}])
				if(entryCriteriaReorderArray.length !== 0){
					const insertionId =  {id: entryCriteria.id, name: entryCriteria.name}
					setEntryCriteriaReorderArray(prev=> [...prev, JSON.stringify(insertionId)])
				  }
				 setEntryListwithInsert([...entryListwithInsert, entryCriteria])

				setEntryCriteriaSuggestions([
					...entryCriteriaSuggestions,
					entryCriteriaJson,
				]);
				setEntryCriteriaWithSuggestions([
					...entryCriteriaWithSuggestions,
					entryCriteriaJson,
				]);
				setInitialEntryCriteriaBeforeReorder([
					...initialEntryCriteriaBeforeReorder,
					entryCriteriaJson,
				]);

				setCriteriaName('');
				setCriteriaDescription('');
				setCriteriaType(defaultCriteriType);
				setError(false);
			}
		} else {
			setError(true);
		}
	};


	const updateInput = () => {
		if (inputDescription !== '' && inputDescription.trim().length !== 0) {
			if (inputEditMode) {
				if (inputList.some((item) => item.id === inputUpdateId)) {
					const updatedDtails = entryCriteriaWithSuggestions.map((item) =>
						JSON.parse(item).id === inputUpdateId
							? JSON.stringify({
								...JSON.parse(item),
								suggestionType: 'updation',
								suggestionId: uniqueIdGenerator(),
								authorId: CkEditorCurrentUser,
								createdAt: new Date(),
								name: inputDescription,
								valueType: 0,
							})
							: item
					);
					setEntryCriteriaWithSuggestions([...updatedDtails]);

					if (
						!entryCriteriaSuggestions.some(
							(item) => JSON.parse(item).id === inputUpdateId
						)
					) {
						const entryCriteria = inputList
							.filter((item) => item.id === inputUpdateId)
							.map((value) => {
								return JSON.stringify({
									...value,
									suggestionType: 'updation',
									suggestionId: uniqueIdGenerator(),
									authorId: CkEditorCurrentUser,
									createdAt: new Date(),
									name: inputDescription,
									valueType: 0,
								});
							});
						setEntryCriteriaSuggestions((prevState) => [
							...prevState,
							...entryCriteria,
						]);
					} else {
						const updatedSuggestions = entryCriteriaSuggestions.map((item) =>
							JSON.parse(item).id === inputUpdateId
								? JSON.stringify({
									...JSON.parse(item),
									suggestionType: 'updation',
									suggestionId: uniqueIdGenerator(),
									authorId: CkEditorCurrentUser,
									createdAt: new Date(),
									name: inputDescription,
									valueType: 0,
								})
								: item
						);
						setEntryCriteriaSuggestions([...updatedSuggestions]);
					}
				} else {
					const updatedDtails = entryCriteriaWithSuggestions.map((item) =>
						JSON.parse(item).id === inputUpdateId
							? JSON.stringify({
								...JSON.parse(item),
								authorId: CkEditorCurrentUser,
								createdAt: new Date(),
								name: inputDescription,
								valueType: 0,
							})
							: item
					);
					const updateSuggestions = entryCriteriaSuggestions.map((item) =>
						JSON.parse(item).id === inputUpdateId
							? JSON.stringify({
								...JSON.parse(item),
								authorId: CkEditorCurrentUser,
								createdAt: new Date(),
								name: inputDescription,
								valueType: 0,
							})
							: item
					);
					setEntryCriteriaSuggestions([...updateSuggestions]);
					setEntryCriteriaWithSuggestions([...updatedDtails]);
				}
				setInputEditMode(false);
				setInputDescription('');
				setInputUpdateId(0);
				setError(false);
			}
			else {
				const entryCriteria = {
					id: uniqueIdGenerator(),
					suggestionId: uniqueIdGenerator(),
					name: inputDescription,
					criteriaType: 'Entry',
					valueType: 0,
					status: 'new',
					criteriaTypeID: 3,
					criteriaTypeName: 'Input',
					suggestionType: 'insertion',
					authorId: CkEditorCurrentUser,
					createdAt: new Date(),
					sequence: entryCriteriaWithSuggestions.filter(e=>JSON.parse(e).criteriaTypeID === 3).length + 1
				};


				if(inputCriteriaReorderArray.length !== 0){
					const insertionId =  {id: entryCriteria.id, name: entryCriteria.name}
					setInputCriteriaReorderArray(prev=> [...prev, JSON.stringify(insertionId)])
				}
				setInputListwithInsert([...inputListwithInsert, entryCriteria])
				const entryCriteriaJson = JSON.stringify(entryCriteria);
				setAddedEntrySequence(prev=>[...prev, {id:JSON.parse(entryCriteriaJson).id,

					sequence:JSON.parse(entryCriteriaJson).sequence,criteriaTypeID:JSON.parse(entryCriteriaJson).criteriaTypeID}])

				
				setEntryCriteriaSuggestions([
					...entryCriteriaSuggestions,
					entryCriteriaJson,
				]);
				setEntryCriteriaWithSuggestions([
					...entryCriteriaWithSuggestions,
					entryCriteriaJson,
				]);
				setInitialInputCriteriaBeforeReorder([
					...initialInputCriteriaBeforeReorder,
					entryCriteriaJson,
				])
				setInputDescription('');
				setError(false);
			}
		} else {
			setError(true);
		}
	};
	const deleteOtherDetails = (item) => {
		const entryCriteria = {
			...item,
			suggestionId: uniqueIdGenerator(),
			suggestionType: 'deletion',
			authorId: CkEditorCurrentUser,
			createdAt: new Date(),
		};
		const entryCriteriaJson = JSON.stringify(entryCriteria);

		setEntryCriteriaSuggestions([
			entryCriteriaJson,
			...entryCriteriaSuggestions,
		]);

		const updatedSuggestions = entryCriteriaWithSuggestions.map((value) =>
			JSON.parse(value).id !== item.id
				? value
				: JSON.stringify({
					...JSON.parse(value),
					suggestionId: uniqueIdGenerator(),
					suggestionType: 'deletion',
					authorId: CkEditorCurrentUser,
					createdAt: new Date(),
				})
		);
		setEntryCriteriaWithSuggestions([...updatedSuggestions]);
	};

	
	const removeSuggestion = (value) => {
		const filteredValue = entryCriteriaSuggestions.filter(
			(item) => JSON.parse(item).id !== JSON.parse(value).id
		);
		setEntryCriteriaSuggestions([...filteredValue]);
		if (
			pageType.includes(source) &&
			JSON.parse(value).authorId !== CkEditorCurrentUser
		) {
			setReviewedEntryCriteriaSuggestions(prev =>
				Array.isArray(prev)
					? [...prev, JSON.stringify({ id: JSON.parse(value).id, state: 'rejected' })]
					: [JSON.stringify({ id: JSON.parse(value).id, state: 'rejected' })]
			);
			
			const criteriaType = JSON.parse(value).criteriaTypeName;
			if(entryContributionReorder && ckEditorCurrentEntryReorderUsername !== user.profile.firstName + ' '+user.profile.surname
			    && criteriaType === 'Entry Criteria' && JSON.parse(value).suggestionType==='insertion'){
			    const initialEntry = initialEntryCriteriaBeforeReorder.filter(e=> JSON.parse(e).id !== JSON.parse(value).id).map(e=>JSON.parse(e).id)
			    const filteredEntry = entryCriteriaWithSuggestions.filter(e=>JSON.parse(e).criteriaTypeName === 'Entry Criteria')
			    const currentEntry = filteredEntry.filter(e=> JSON.parse(e).id !== JSON.parse(value).id).map(e=>JSON.parse(e).id)
				const isSimilar = initialEntry.some((element, index) => element !== currentEntry[index])
				if(!isSimilar){
				  removeReorderedSuggestions('Entry');
				  toast.info('Reorder suggestion has rejected automatically', {
					position: toast.POSITION.TOP_RIGHT,
				  });
				}
			  }
		}
		if (
			source === 'approve'
			&& JSON.parse(value).authorId === CkEditorCurrentUser
			&& reviewerEntryCriteriaSuggestions?.some((item) => JSON.parse(item).id === JSON.parse(value).id)
		) {
			setReviewedEntryCriteriaSuggestions([
				...reviewedEntryCriteriaSuggestions,
				JSON.stringify({ id: JSON.parse(value).id, state: 'rejected' }),
			]);
		}
		if (entryCriteriaList.some((item) => item.id === JSON.parse(value).id)) {
			const updatedList = entryCriteriaWithSuggestions.map((item) =>
				JSON.parse(item).id === JSON.parse(value).id
					? JSON.stringify({
						...entryCriteriaList.filter(
							(item) => JSON.parse(value).id === item.id
						)[0],
						suggestionType: 'none',
						suggestionId: null,
						authorId: CkEditorCurrentUser,
						createdAt: new Date(),
					})
					: item
			);

			setEntryCriteriaWithSuggestions([...updatedList]);
		    setInitialEntryIdBeforeReorder(prev=> prev.filter(e=>JSON.parse(e).id !== JSON.parse(value).id))

		} else {

			const filteredList = entryCriteriaWithSuggestions.filter(
				(item) => JSON.parse(item).id !== JSON.parse(value).id
			);
			const initialEntryFilteredList = initialEntryCriteriaBeforeReorder.filter(
				(item) => JSON.parse(item).id !== JSON.parse(value).id
			);
			
			setEntryCriteriaWithSuggestions([...filteredList]);
			setInitialEntryCriteriaBeforeReorder(prev=> prev.filter(e=>JSON.parse(e).id !== JSON.parse(value).id))
            setEntryListwithInsert([...initialEntryFilteredList.map(e=>JSON.parse(e))])
            setEntryCriteriaReorderArray(prev=> prev.filter(e=>JSON.parse(e).id !== JSON.parse(value).id))
		}
	};
	const acceptSuggestion = (value) => {
		//setEntryCriteriaList([...entryCriteriaList, JSON.parse(item)]);
		if (JSON.parse(value).suggestionType === 'deletion') {
			const criteriaType = JSON.parse(value).criteriaTypeName;
			if(entryContributionReorder && ckEditorCurrentEntryReorderUsername !== user.profile.firstName + ' '+user.profile.surname
			    && criteriaType === 'Entry Criteria'){
				const initialEntry = initialEntryCriteriaBeforeReorder.filter(e=> JSON.parse(e).id !== JSON.parse(value).id).map(e=>JSON.parse(e).id)
				const filteredEntry = entryCriteriaWithSuggestions.filter(e=>JSON.parse(e).criteriaTypeName === 'Entry Criteria')
				const currentEntry = filteredEntry.filter(e=> JSON.parse(e).id !== JSON.parse(value).id).map(e=>JSON.parse(e).id)
				const isSimilar = initialEntry.some((element, index) => element !== currentEntry[index])
				if(!isSimilar){
				  removeReorderedSuggestions('Entry');
				  toast.info('Reorder suggestion has rejected automatically', {
					position: toast.POSITION.TOP_RIGHT,
				  });
				}
			}
			
			if (entryCriteriaList.some((item) => item.id === JSON.parse(value).id)) { 
				const updatedEntryCriteria = entryCriteriaList.filter(
					(item) => item.id !== JSON.parse(value).id
				);
				setEntryCriteriaList([...updatedEntryCriteria]);
				const updatedDataList = entryCriteriaData.filter(
					(item) => item.id !== JSON.parse(value).id
				);
				setEntryCriteriaData([...updatedDataList]);
				const filteredList = entryCriteriaWithSuggestions.filter(
					(item) => JSON.parse(item).id !== JSON.parse(value).id
				);
				setEntryCriteriaWithSuggestions([...filteredList]);
				setInitialEntryCriteriaBeforeReorder(prev=> prev.filter(e=>JSON.parse(e).id !== JSON.parse(value).id))
				if(entryCriteriaReorderArray !== null){
				  setEntryCriteriaReorderArray(prev=>prev.filter(e=>JSON.parse(e).id !== JSON.parse(value).id))
				}
			} else {
				const filteredList = entryCriteriaWithSuggestions.filter(
					(item) => JSON.parse(item).id !== JSON.parse(value).id
				);
				setEntryCriteriaWithSuggestions([...filteredList]);
			}
		} else {
			const updatedList = entryCriteriaWithSuggestions.map((item) =>
				JSON.parse(item).id === JSON.parse(value).id
					? JSON.stringify({
						...JSON.parse(item),
						suggestionType: 'none',
						suggestionId: null,
						authorId: CkEditorCurrentUser,
						createdAt: new Date(),
					})
					: item
			);
			setEntryCriteriaWithSuggestions([...updatedList]);
			
			if (!entryCriteriaList.some((item) => item.id === JSON.parse(value).id)) {
				const criteria = {
					id: JSON.parse(value).id,
					name: JSON.parse(value).name,
					criteriaType: JSON.parse(value).criteriaType,
					valueType: JSON.parse(value).valueType,
					createdDate: JSON.parse(value).createdDate,
					createdBy: JSON.parse(value).authorId,
					criteriaTypeID: JSON.parse(value).criteriaTypeID,
					criteriaTypeName: JSON.parse(value).criteriaTypeName,
					sequence:entryCriteriaList.indexOf(entryCriteriaList.length-1) + 2
				};
				    let increment = 1;
				    const updatedEntryData = ([...entryCriteriaData, criteria])
					updatedEntryData.forEach((e,i)=>{
						if(e.criteriaTypeID === 1){
							e.sequence = increment;
                            increment ++
						} 
					})
				setEntryCriteriaData(updatedEntryData);
				setEntryCriteriaList([...entryCriteriaList, criteria]);
			} else {
				const updatedList = entryCriteriaList.map((item) =>
					item.id === JSON.parse(value).id ? JSON.parse(value) : item
				);
				setEntryCriteriaList([...updatedList]);
				const updatedData = entryCriteriaData.map((item) =>
					item.id === JSON.parse(value).id ? JSON.parse(value) : item
				);
				setEntryCriteriaData([...updatedData]);
			}
		}

		const filteredValue = entryCriteriaSuggestions.filter(
			(item) => JSON.parse(item).id !== JSON.parse(value).id
		);
		setEntryCriteriaSuggestions([...filteredValue]);

		setReviewedEntryCriteriaSuggestions([
			...reviewedEntryCriteriaSuggestions,
			JSON.stringify({ id: JSON.parse(value).id, state: 'accepted' }),
		]);
	};

	const acceptEntryReorderSuggestion = ()=>{
		const isNotCurrentUser = entryCriteriaSuggestions.some(e=>JSON.parse(e).authorId !== CkEditorCurrentUser )
		if(entryCriteriaSuggestions && entryCriteriaSuggestions.length !==0 && isNotCurrentUser){
			toast.error('Please accept or reject other Entry/Input suggestions before accepting reorder', {
				position: toast.POSITION.TOP_RIGHT,
			  })
		} else {
		setReviewedReorderedEntrySuggestions([JSON.stringify({ id: uniqueIdGenerator(), state: 'accepted',name:'Entry' })])
		  setEntryContributionReorder(false);		 
		  const currentEntryCriteria = entryCriteriaWithSuggestions.filter(e=>JSON.parse(e).criteriaTypeName
		=== 'Entry Criteria')

		setInitialEntryCriteriaBeforeReorder(currentEntryCriteria)
		setReorderContributionCount((prev)=> prev - 1)
		}
	}
	
	const acceptInputReorderSuggestion = ()=>{
		const isNotCurrentUser = entryCriteriaSuggestions.some(e=>JSON.parse(e).authorId !== CkEditorCurrentUser )
		if(entryCriteriaSuggestions && entryCriteriaSuggestions.length !==0 && isNotCurrentUser){
			toast.error('Please accept or reject other Entry/Input suggestions before accepting reorder', {
				position: toast.POSITION.TOP_RIGHT,
			  })
		}else{
		setReviewedReorderedInputSuggestions([JSON.stringify({ id: uniqueIdGenerator(), state: 'accepted',name:'Input' })])
		  setInputContributionReorder(false);	
		  const currentInputCriteria = entryCriteriaWithSuggestions.filter(e=>JSON.parse(e).criteriaTypeName
		  === 'Input')
  
		  setInitialInputCriteriaBeforeReorder(currentInputCriteria)
		  setReorderContributionCount((prev)=> prev - 1)
		  }
			 
	}

	const removeReorderedSuggestions = (field) => {
        
		const parsedTasks = entryCriteriaWithSuggestions.map((item) => {
			return JSON.parse(item)
		})
		if (field === 'Entry') {
			const filteredEntryParsed = parsedTasks.filter((item) => {
				return item.criteriaTypeName === "Entry Criteria"
			})
			//Creating this for Concatination. Parse Not required
			const  filteredInputParsed = entryCriteriaWithSuggestions.filter((item) => {
				return JSON.parse(item).criteriaTypeName === "Input"
			})
			const parsedInitialEntryCriteriaBeforeReorder = initialEntryCriteriaBeforeReorder.map(e=>JSON.parse(e))
			const parsedArray = filteredEntryParsed.map((item) => {
				return JSON.stringify({
					...item,
					sequence: parsedInitialEntryCriteriaBeforeReorder.filter((v) => v.id === item.id)[0].sequence,
					authorId: item.authorId !== CkEditorCurrentUser ? item.authorId :CkEditorCurrentUser,
					createdAt: new Date(),
				})
			})
			const beforeSortingArray = parsedArray.map((item) => {
				return JSON.parse(item)
			})
			beforeSortingArray.sort((a, b) => a.sequence - b.sequence)

			const afterSortAndStringify = beforeSortingArray.map((item) => {
				return JSON.stringify(item)
			})
			setEntryCriteriaWithSuggestions([...afterSortAndStringify.concat(filteredInputParsed)]);
			setEntryContributionReorder(false)
			setEntryCriteriaReorderArray([])
			if(source === 'review'){
				setIsReviewerEntryReordered(false)
			}
			if(source === 'approve'){
	            setIsApproverEntryReordered(false)
			}
			if (
				pageType.includes(source) && ckEditorCurrentEntryReorderUsername !== user.profile.firstName + ' '+user.profile.surname
				
			  ) {
				setReviewedReorderedEntrySuggestions([JSON.stringify({ id: uniqueIdGenerator(), state: 'rejected',name:'Entry' })])
				setReorderContributionCount((prev)=> prev - 1)
			}
			setDisableEntryDrag(false)
		}
		else {
			const filteredInputParsed = parsedTasks.filter((item) => {
				return item.criteriaTypeName === "Input"
			})
            //Creating this for Concatination. Parse Not required

			const  filteredEntryParsed = entryCriteriaWithSuggestions.filter((item) => {
				return JSON.parse(item).criteriaTypeName === "Entry Criteria"
			})
			const parsedInitialInputCriteriaBeforeReorder = initialInputCriteriaBeforeReorder.map(e=>JSON.parse(e))
			const parsedArray = filteredInputParsed.map((item) => {
				return JSON.stringify({
					...item,
					sequence: parsedInitialInputCriteriaBeforeReorder.filter((v) => v.id === item.id)[0].sequence,
					authorId: item.authorId !== CkEditorCurrentUser ? item.authorId :CkEditorCurrentUser,
					createdAt: new Date(),
				})
			})
			const beforeSortingArray = parsedArray.map((item) => {
				return JSON.parse(item)
			})
			beforeSortingArray.sort((a, b) => a.sequence - b.sequence)

			const afterSortAndStringify = beforeSortingArray.map((item) => {
				return JSON.stringify(item)
			})
			setEntryCriteriaWithSuggestions([...filteredEntryParsed.concat(afterSortAndStringify)]);
			setInputContributionReorder(false)
			setInputCriteriaReorderArray([])
			if(source === 'review'){
				setIsReviewerInputReordered(false)
			}
			if(source === 'approve'){
	            setIsApproverInputReordered(false)
			}
			if (pageType.includes(source) && ckEditorCurrentInputReorderUsername !== user.profile.firstName + ' '+user.profile.surname)
			  {
				setReviewedReorderedInputSuggestions([JSON.stringify({ id: uniqueIdGenerator(), state: 'rejected',name:'Input' })])
				setReorderContributionCount((prev)=> prev - 1)
			}
			setDisableInputDrag(false) 
		}
		
	}
	const removeInputSuggestion = (value) => {
		const filteredValue = entryCriteriaSuggestions.filter(
			(item) => JSON.parse(item).id !== JSON.parse(value).id
		);
		setEntryCriteriaSuggestions([...filteredValue]);
		if (
			pageType.includes(source) &&
			JSON.parse(value).authorId !== CkEditorCurrentUser
		) {
			setReviewedEntryCriteriaSuggestions([
				...reviewedEntryCriteriaSuggestions,
				JSON.stringify({ id: JSON.parse(value).id, state: 'rejected' }),
			]);
			const criteriaType = JSON.parse(value).criteriaTypeName;
			if(inputContributionReorder && ckEditorCurrentInputReorderUsername !== user.profile.firstName + ' '+user.profile.surname 
			   && criteriaType === 'Input' && JSON.parse(value).suggestionType==='insertion'){
				const initialInput = initialInputCriteriaBeforeReorder.filter(e=> JSON.parse(e).id !== JSON.parse(value).id).map(e=>JSON.parse(e).id)
				const filteredInput = entryCriteriaWithSuggestions.filter(e=>JSON.parse(e).criteriaTypeName === 'Input')
				const currentInput = filteredInput.filter(e=> JSON.parse(e).id !== JSON.parse(value).id).map(e=>JSON.parse(e).id)
				const isSimilar = initialInput.some((element, index) => element !== currentInput[index])
				if(!isSimilar){
				  removeReorderedSuggestions('Input');
				  toast.info('Reorder suggestion has rejected automatically', {
					position: toast.POSITION.TOP_RIGHT,
				  });
				}
			  }
		}
		if (
			source === 'approve'
			&& JSON.parse(value).authorId === CkEditorCurrentUser
			&& reviewerEntryCriteriaSuggestions?.some((item) => JSON.parse(item).id === JSON.parse(value).id)
		) {
			setReviewedEntryCriteriaSuggestions([
				...reviewedEntryCriteriaSuggestions,
				JSON.stringify({ id: JSON.parse(value).id, state: 'rejected' }),
			]);
		}
		if (inputList.some((item) => item.id === JSON.parse(value).id)) {
			const updatedList = entryCriteriaWithSuggestions.map((item) =>
				JSON.parse(item).id === JSON.parse(value).id
					? JSON.stringify({
						...inputList.filter(
							(item) => JSON.parse(value).id === item.id
						)[0],
						suggestionType: 'none',
						suggestionId: null,
						authorId: CkEditorCurrentUser,
						createdAt: new Date(),
					})
					: item
			);

			setEntryCriteriaWithSuggestions([...updatedList]);
		} else {
			const filteredList = entryCriteriaWithSuggestions.filter(
				(item) => JSON.parse(item).id !== JSON.parse(value).id
			);
			const initialInputFilteredList = initialInputCriteriaBeforeReorder.filter(
				(item) => JSON.parse(item).id !== JSON.parse(value).id
			);
			
			setEntryCriteriaWithSuggestions([...filteredList]);
			setInitialInputCriteriaBeforeReorder(prev=> prev.filter(e=>JSON.parse(e).id !== JSON.parse(value).id))
			setInputListwithInsert([...initialInputFilteredList.map(e=>JSON.parse(e))])
            setInputCriteriaReorderArray(prev=> prev.filter(e=>JSON.parse(e).id !== JSON.parse(value).id))
		}
	};

	const acceptInputSuggestion = (value) => {
		//setEntryCriteriaList([...entryCriteriaList, JSON.parse(item)]);
		if (JSON.parse(value).suggestionType === 'deletion') {
			const criteriaType = JSON.parse(value).criteriaTypeName;
			if(inputContributionReorder && ckEditorCurrentInputReorderUsername !== user.profile.firstName + ' '+user.profile.surname 
			   && criteriaType === 'Input'){
				const initialInput = initialInputCriteriaBeforeReorder.filter(e=> JSON.parse(e).id !== JSON.parse(value).id).map(e=>JSON.parse(e).id)
				const filteredInput = entryCriteriaWithSuggestions.filter(e=>JSON.parse(e).criteriaTypeName === 'Input')
				const currentInput = filteredInput.filter(e=> JSON.parse(e).id !== JSON.parse(value).id).map(e=>JSON.parse(e).id)
				const isSimilar = initialInput.some((element, index) => element !== currentInput[index])
				if(!isSimilar){
				  removeReorderedSuggestions('Input');
				  toast.info('Reorder suggestion has rejected automatically', {
					position: toast.POSITION.TOP_RIGHT,
				  });
				}
			  }
			if (inputList.some((item) => item.id === JSON.parse(value).id)) {
				const updatedEntryCriteria = inputList.filter(
					(item) => item.id !== JSON.parse(value).id
				);
				setInputList([...updatedEntryCriteria]);
				const updatedDataList = entryCriteriaData.filter(
					(item) => item.id !== JSON.parse(value).id
				);
				setEntryCriteriaData([...updatedDataList]);
				const filteredList = entryCriteriaWithSuggestions.filter(
					(item) => JSON.parse(item).id !== JSON.parse(value).id
				);
				setEntryCriteriaWithSuggestions([...filteredList]);
				setInitialInputCriteriaBeforeReorder(prev=> prev.filter(e=>JSON.parse(e).id !== JSON.parse(value).id))
                if(inputCriteriaReorderArray !== null){
                setInputCriteriaReorderArray(prev=>prev.filter(e=>JSON.parse(e).id !== JSON.parse(value).id))
        }
			} else {
				const filteredList = entryCriteriaWithSuggestions.filter(
					(item) => JSON.parse(item).id !== JSON.parse(value).id
				);
				setEntryCriteriaWithSuggestions([...filteredList]);
			}
		} else {
			const updatedList = entryCriteriaWithSuggestions.map((item) =>
				JSON.parse(item).id === JSON.parse(value).id
					? JSON.stringify({
						...JSON.parse(item),
						suggestionType: 'none',
						suggestionId: null,
						authorId: CkEditorCurrentUser,
						createdAt: new Date(),
					})
					: item
			);
			setEntryCriteriaWithSuggestions([...updatedList]);
			if (!inputList.some((item) => item.id === JSON.parse(value).id)) {
				const criteria = {
					id: JSON.parse(value).id,   
					name: JSON.parse(value).name,
					criteriaType: JSON.parse(value).criteriaType,
					valueType: JSON.parse(value).valueType,
					createdDate: JSON.parse(value).createdDate,
					createdBy: JSON.parse(value).authorId,
					criteriaTypeID: JSON.parse(value).criteriaTypeID,
					criteriaTypeName: JSON.parse(value).criteriaTypeName,
					sequence: inputList.indexOf(inputList.length-1) + 2
				};
				let increment = 1;
                const updatedInputData = ([...entryCriteriaData, criteria])
				updatedInputData.forEach((e,i)=>{
					if(e.criteriaTypeID === 3){
						e.sequence = increment;
						increment ++
					} 
				})
				setEntryCriteriaData(updatedInputData);
				setInputList([...inputList, criteria]);
			} else {
				const updatedList = inputList.map((item) =>
					item.id === JSON.parse(value).id ? JSON.parse(value) : item
				);
				setInputList([...updatedList]);
				const updatedData = entryCriteriaData.map((item) =>
					item.id === JSON.parse(value).id ? JSON.parse(value) : item
				);
				setEntryCriteriaData([...updatedData]);
			}
		}

		const filteredValue = entryCriteriaSuggestions.filter(
			(item) => JSON.parse(item).id !== JSON.parse(value).id
		);
		setEntryCriteriaSuggestions([...filteredValue]);

		setReviewedEntryCriteriaSuggestions([
			...reviewedEntryCriteriaSuggestions,
			JSON.stringify({ id: JSON.parse(value).id, state: 'accepted' }),
		]);
	};

	const handleCriteriaDescription = (event) => {
		setCriteriaDescription(event.target.value);
	};

	const handleInputDescription = (event) => {
		setInputDescription(event.target.value);
	};

	useEffect(()=>{
		const currentEntryCriteria = entryCriteriaWithSuggestions.filter(e=>JSON.parse(e).criteriaTypeName
		=== 'Entry Criteria').map(e=>JSON.parse(e).id)

		const currentInputCriteria = entryCriteriaWithSuggestions.filter(e=>JSON.parse(e).criteriaTypeName
		=== 'Input').map(e=>JSON.parse(e).id)
		const arraysAreEqual =(arr1, arr2) => {
			if(!arr1 && !arr2){
				return false
			}
			const initial = arr1.map((e) => JSON.parse(e).id);
;			if (arr1.length !== initial.length) {
			  return false;
			}
		  return initial.some((element, index) => element !== arr2[index]);
		  }
        const entryHasChanged = arraysAreEqual(initialEntryCriteriaBeforeReorder, currentEntryCriteria)
		
		const inputHasChanged = arraysAreEqual(initialInputCriteriaBeforeReorder, currentInputCriteria)
		setEntryContributionReorder(entryHasChanged)
		setIsOrderChanged(prevState => ({
			...prevState,
			entry: entryHasChanged 
		  }))

		setInputContributionReorder(inputHasChanged)
		setIsOrderChanged(prevState => ({
			...prevState,
			input: inputHasChanged 
		  }))
	
	},[entryCriteriaWithSuggestions])



    
	const renderSuggestions = () => {
		return (
			<div
				className={`toolsSidebar ${currentEntryTab === 'tab-entry' ? '' : 'hiddenEntryCriteria'
					} `}
				style={{ minHeight: toolsSidebarHeight, maxHeight:'300px' }}
			>
				{
					entryContributionReorder && <>
						<div className='sideBarCard userAddedItem'>
							<div className="sideBarCardHeader">
								<img
									className="userImg"
									src={ckEditorCurrentEntryReorderUserImage}
									alt=""
								/>
								<span>{ckEditorCurrentEntryReorderUsername} </span>
								<Icon
									title="Reject Suggestion"
									ariaLabel={`Click to reject the Reorder`}
									role="button"
									iconName="Cancel"
									onClick={() => removeReorderedSuggestions('Entry')}
									onKeyPress={(e) => {
										if (e.which === 13) {
											removeReorderedSuggestions('Entry');
										}
									}}
									tabIndex={0}
								/>
							 {pageType.includes(source) &&
							 ckEditorCurrentEntryReorderUsername !== user.profile.firstName + ' '+user.profile.surname &&
                                 (
                                        <Icon
                                  title="Accept Suggestion"
                                  iconName="Accept"
                                  onClick={() => acceptEntryReorderSuggestion()}
                                  onKeyPress={(e) => {
                                    if (e.which === 13) {
                                      acceptEntryReorderSuggestion();
                                    }
                                  }}
                                  ariaLabel={'click to accept as suggestion'}
                                  role="button"
                                  tabIndex={0}
                                />
                              
                              )}
								<div className="itemStatus">
									<span>
										Reordered
									</span>
									&nbsp;"Description: Entry Criteria has been Reordered"
								</div>

							</div>
						</div>

					</>
				}
				{entryCriteriaSuggestions &&
					entryCriteriaWithSuggestions.map((card) => (
						<>
							{JSON.parse(card).criteriaTypeName === 'Entry Criteria' &&
								(JSON.parse(card).suggestionType === 'none' ? (
									<></>
								) : (
									<div
										className={`sideBarCard ${JSON.parse(card).suggestionType === 'deletion'
											? 'userDeletedToolsAndGuidance'
											: 'userAddedItem'
											}`}
									>
										<div className="sideBarCardHeader">
											<img
												className="userImg"
												src={ckEditorUserMap[JSON.parse(card).authorId][1]}
												alt=""
											/>
											<span className='nonCkEditorAuthor'>
												{ckEditorUserMap[JSON.parse(card).authorId][0]}
											</span>

											{JSON.parse(card).authorId === CkEditorCurrentUser ||
												(pageType.includes(source) &&
													JSON.parse(card).authorId !== CkEditorCurrentUser) ? (
												<Icon
													title="Reject Suggestion"
													ariaLabel={`Click to reject ${JSON.parse(card).name
														} as suggestion`}
													role="button"
													iconName="Cancel"
													onClick={() => removeSuggestion(card)}
													onKeyPress={(e) => {
														if (e.which === 13) {
															removeSuggestion(card);
														}
													}}
													tabIndex={0}
												/>
											) : (
												<></>
											)}
											{pageType.includes(source) &&
												JSON.parse(card).authorId !== CkEditorCurrentUser ? (
												<Icon
													title="Accept Suggestion"
													iconName="Accept"
													onClick={() => acceptSuggestion(card)}
													onKeyPress={(e) => {
														if (e.which === 13) {
															acceptSuggestion(card);
														}
													}}
													ariaLabel={`Click to Accept ${JSON.parse(card).name
														} as suggestion`}
													role="button"
													tabIndex={0}
												/>
											) : (
												<></>
											)}
										</div>
										<div className="itemStatus">
											<span>
												{JSON.parse(card).suggestionType === 'insertion'
													? 'Add'
													: JSON.parse(card).suggestionType === 'deletion'
														? 'Remove'
														: 'Edit'}
											</span>
											&nbsp;"Text/Numeric:
											{JSON.parse(card).valueType === 1
												? 'Text'
												: 'Numeric'}{' '}
											Description:{JSON.parse(card).name}"
										</div>
									</div>
								))}
						</>
					))}
			</div>
		);
	};
	const renderInputSuggestions = () => {
		return (
			<div
				className={`toolsSidebar ${currentEntryTab === 'tab-entry' ? 'hiddenExitCriteria' : ''
					} `}
				style={{ minHeight: toolsSidebarHeight }}
			>
				{
					inputContributionReorder && <>
						<div className='sideBarCard userAddedItem'>
							<div className="sideBarCardHeader">
								<img
									className="userImg"
									src={ckEditorCurrentInputReorderUserImage}
									alt=""
								/>
								<span>{ckEditorCurrentInputReorderUsername}</span>
								<Icon
									title="Reject Suggestion"
									ariaLabel={`Click to reject the Reorder`}
									role="button"
									iconName="Cancel"
									onClick={() => removeReorderedSuggestions('Input')}
									onKeyPress={(e) => {
										if (e.which === 13) {
											removeReorderedSuggestions('Input');
										}
									}}
									tabIndex={0}
								/>
								{pageType.includes(source) &&
								ckEditorCurrentInputReorderUsername !== user.profile.firstName + ' '+user.profile.surname &&
                               (
                               <Icon
                                 title="Accept Suggestion"
                                 iconName="Accept"
                                 onClick={() => acceptInputReorderSuggestion()}
                                 onKeyPress={(e) => {
                                   if (e.which === 13) {
									acceptInputReorderSuggestion();
                                   }
                                 }}
                                 ariaLabel={'click to accept as suggestion'}
                                 role="button"
                                 tabIndex={0}
                               />
                             
                             )}
								<div className="itemStatus">
									<span>
										Reordered
									</span>
									&nbsp;"Description: Input Criteria has been Reordered"
								</div>

							</div>
						</div>
					</>
				}
				{entryCriteriaSuggestions &&
					entryCriteriaWithSuggestions.map((card) => (
						<>
							{JSON.parse(card).criteriaTypeName === 'Input' &&
								(JSON.parse(card).suggestionType === 'none' ? (
									<></>
								) : (
									<div
										className={`sideBarCard ${JSON.parse(card).suggestionType === 'deletion'
											? 'userDeletedToolsAndGuidance'
											: 'userAddedItem'
											}`}
									>
										<div className="sideBarCardHeader">
											<img
												className="userImg"
												src={ckEditorUserMap[JSON.parse(card).authorId][1]}
												alt=""
											/>
											<span className='nonCkEditorAuthor'>
												{ckEditorUserMap[JSON.parse(card).authorId][0]}
											</span>

											{JSON.parse(card).authorId === CkEditorCurrentUser ||
												(pageType.includes(source) &&
													JSON.parse(card).authorId !== CkEditorCurrentUser) ? (
												<Icon
													title="Reject Suggestion"
													ariaLabel={`Click to reject ${JSON.parse(card).name
														} as suggestion`}
													role="button"
													iconName="Cancel"
													onClick={() => removeInputSuggestion(card)}
													onKeyPress={(e) => {
														if (e.which === 13) {
															removeInputSuggestion(card);
														}
													}}
													tabIndex={0}
												/>
											) : (
												<></>
											)}
											{pageType.includes(source) &&
												JSON.parse(card).authorId !== CkEditorCurrentUser ? (
												<Icon
													title="Accept Suggestion"
													iconName="Accept"
													onClick={() => acceptInputSuggestion(card)}
													onKeyPress={(e) => {
														if (e.which === 13) {
															acceptInputSuggestion(card);
														}
													}}
													ariaLabel={`Click to Accept ${JSON.parse(card).name
														} as suggestion`}
													role="button"
													tabIndex={0}
												/>
											) : (
												<></>
											)}
										</div>
										<div className="itemStatus">
											<span>
												{JSON.parse(card).suggestionType === 'insertion'
													? 'Add'
													: JSON.parse(card).suggestionType === 'deletion'
														? 'Remove'
														: 'Edit'}
											</span>
											&nbsp;"
											{JSON.parse(card).name}"
										</div>
									</div>
								))}
						</>
					))}
			</div>
		);
	};
	
	  const getFilteredItems = (tab) => {
		return entryCriteriaWithSuggestions
		  .map((item) => JSON.parse(item))
		  .filter((item) =>
			tab === "tab-entry" ? item.criteriaTypeName === "Entry Criteria" : item.criteriaTypeName === "Input",
		  )
	  }

	

	  const handleAddItem = () => {
		if (newItemDescription.trim() === "") {
		  setError(true)
		  return
		}
	
		const newItem = {
		  id: uniqueIdGenerator(),
		  name: newItemDescription,
		  description: "",
		  criteriaType: "Entry",
		  valueType: currentEntryTab === "tab-entry" ? criteriaType.id : 0,
		  activityId: null,
		  complexityId: 3,
		  createdDate: new Date().toISOString(),
		  modifiedDate: new Date().toISOString(),
		  createdBy: CkEditorCurrentUser,
		  modifiedBy: CkEditorCurrentUser,
		  criteriaTypeID: currentEntryTab === "tab-entry" ? 1 : 3,
		  criteriaTypeName: currentEntryTab === "tab-entry" ? "Entry Criteria" : "Input",
		  sequence: getFilteredItems(currentEntryTab).length + 1,
		  suggestionType: "insertion",
		  authorId: CkEditorCurrentUser,
		  suggestionId: uniqueIdGenerator(),
		  createdAt: new Date().toISOString(),
		}
	
		setEntryCriteriaWithSuggestions((prev) => [...prev, JSON.stringify(newItem)])
		setEntryCriteriaSuggestions((prev) => [...prev, JSON.stringify(newItem)]);
		setNewItemDescription("")

		setError(false)
	  }
	  const handleItemChange = (e, index, item) => {
		const value = e.target.value;
	
		setEntryCriteriaWithSuggestions((prev) =>
			prev.map((entry) =>
				JSON.parse(entry).id === item.id
					? JSON.stringify({
						  ...JSON.parse(entry),
						  name: value,
						  suggestionType: "updation",
						  suggestionId: uniqueIdGenerator(),
						  authorId: CkEditorCurrentUser,
						  createdAt: new Date(),
						  valueType: item.valueType, // Preserve valueType from the existing entry
					  })
					: entry
			)
		);
	
		setEntryCriteriaSuggestions((prevState) => {
			if (!prevState.some((entry) => JSON.parse(entry).id === item.id)) {
				const newEntry = JSON.stringify({
					...item,
					name: value,
					suggestionType: "updation",
					suggestionId: uniqueIdGenerator(),
					authorId: CkEditorCurrentUser,
					createdAt: new Date(),
					valueType: item.valueType,
				});
	
				return [...prevState, newEntry];
			} else {
				return prevState.map((entry) =>
					JSON.parse(entry).id === item.id
						? JSON.stringify({
							  ...JSON.parse(entry),
							  name: value,
							  suggestionType: "updation",
							  suggestionId: uniqueIdGenerator(),
							  authorId: CkEditorCurrentUser,
							  createdAt: new Date(),
							  valueType: item.valueType,
						  })
						: entry
				);
			}
		});
	};
	
	
	

	const handleDropdownChange = (tabId, itemId, selectedValue) => {
		setDropdownValues((prev) => ({
			...prev,
			[`${tabId}-${itemId}`]: selectedValue,
		}));
	};
	
	const handleEntryTabClick = (tabId) => {
		setCurrentEntryTab(tabId);
		setCurrentEntryTab(tabId); 
	};	




const handleRemoveButtonClick = (item) => {
    const isEntryItem = item.criteriaTypeName === "Entry Criteria";
    const originalList = isEntryItem ? entryCriteriaList : inputList;

    //  Case 1: If current user created the row & it's not an "updation", remove it
    if (item.createdBy === CkEditorCurrentUser && item.suggestionType !== "updation") {
        setEntryCriteriaWithSuggestions((prev) => prev.filter((entry) => JSON.parse(entry).id !== item.id));
        return;
    }

    //  Find the original item
    let originalItem = originalList.find((entry) => entry.id === item.id) ||
                       entryCriteriaWithSuggestions.find((entry) => JSON.parse(entry).id === item.id);

    if (!originalItem) return console.error(`Original item with ID ${item.id} not found.`);

    //  Case 2: If the current user modified the row, revert it; else, mark "deletion"
    if (item.suggestionType === "updation") {
        setEntryCriteriaWithSuggestions((prev) =>
            prev.map((entry) => JSON.parse(entry).id === item.id
                ? JSON.stringify(item.authorId === CkEditorCurrentUser 
                    ? { ...originalItem, suggestionType: "none" }  // Revert changes
                    : { ...JSON.parse(entry), suggestionType: "deletion", suggestionId: uniqueIdGenerator(), authorId: CkEditorCurrentUser, createdAt: new Date() }) // Mark deletion
                : entry)
        );
        return;
    }

    // Case 3: If it's an existing row (not created by current user), mark "deletion"
    setEntryCriteriaWithSuggestions((prev) =>
        prev.map((entry) => JSON.parse(entry).id === item.id
            ? JSON.stringify({ ...JSON.parse(entry), suggestionType: "deletion", suggestionId: uniqueIdGenerator(), authorId: CkEditorCurrentUser, createdAt: new Date() })
            : entry)
    );
};



const renderTabContent = (tabId) => {
    const items = getFilteredItems(tabId);

    return (
        <div id={tabId} className={`entry-criteria-tab-content ${currentEntryTab === tabId ? "currentEntry" : ""}`}>
            <div>
                {items.map((item, index) => (
                    <div key={item.id}>
                        <div className="addPolygonTopicRelatedInputContainer">
                            <div className="polygonInputContainer">
                                <div className="row">
                                    {tabId === "tab-entry" && (
                                        <div className="px-0">
                                            <Dropdown
                                                className="entryEditCriteriadropdown"
                                                data={dropdownValue}
                                                value={dropdownValues[`${tabId}-${item.id}`] || dropdownValue[0]}
                                                setValue={(selectedValue) => handleDropdownChange(tabId, item.id, selectedValue)}
                                                enableDropdown={!disableControls}
                                                pageType={"Activity"}
												renderFrom={'crowdSourcing'}
                                            />
                                        </div>
                                    )}
                                    <div className={`inputBox p-0`}>
                                        <input
                                            ref={(el) => (inputRefs.current[index] = el)}
                                            className={`entryEditCriteriaInput
                                                ${item.suggestionType === "none" ? "" : 
                                                item.suggestionType === "insertion" ? "addedCriteria" :
                                                item.suggestionType === "updation" ? "updatedCriteria" : 
                                                "deletedCriteria"}`}
                                            onChange={(e) => {handleItemChange(e, index, item)}}
                                            value={item.name}
                                            readOnly={disableControls}
                                            style={disableControls ? { cursor: "default" } : {}}
                                        />
                                    </div>
                                    <div className='d-flex justify-content-center'>
                                        <div className="addPolygonTopicFieldSave ">
                                            <button
                                                disabled={disableControls}
                                                tabIndex={0}
                                                title="Remove"
                                                role="button"
                                                aria-label="Remove"
                                                className={`${disableControls ? 'disableIconsCross relatededitContentDelete' : 'relatededitContentDelete'}`}
                                                onClick={() => handleRemoveButtonClick(item)}
                                            ></button>
                                        </div>
                                        {isHideInputBox && index === items.length - 1 &&
                                            <div className="addPolygonTopicFieldSave">
                                                <button
                                                    disabled={disableControls}
                                                    tabIndex={0}
                                                    title="Add"
                                                    role="button"
                                                    aria-label="Add"
                                                    className={`${disableControls ? 'disableIconsAdd relatedContentAdd' : 'relatedContentAdd'}`}
                                                    onClick={() => setIsHideInputBox(false)}
                                                ></button>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}

                {!isHideInputBox &&
                    <div className="addPolygonTopicRelatedInputContainer">
                        <div className="polygonInputContainer">
                            <div className="row">
                                {tabId === "tab-entry" && (
                                    <div className="px-0">
                                        <Dropdown
                                            className="entryEditCriteriadropdown"
                                            data={dropdownValue}
                                            value={criteriaType}
                                            setValue={setCriteriaType}
                                            enableDropdown={!disableControls}
                                            pageType={"Activity"}
											renderFrom={'crowdSourcing'}
                                        />
                                    </div>
                                )}
                                <div className={`inputBox p-0`}>
                                    <input
                                        value={newItemDescription}
                                        className="entryEditCriteriaInput"
										onChange={(e) => setNewItemDescription(e.target.value)} // Update value on change
										onBlur={(e) => {
											if (e.relatedTarget?.getAttribute("aria-label") !== "Remove") {handleAddItem()}
										}} 
                                        placeholder={`Enter new ${tabId === "tab-entry" ? "Entry Criteria" : "Input"}`}
                                        readOnly={disableControls}
                                        style={disableControls ? { cursor: "default" } : {}}
                                    />
                                </div>
                                <div className='d-flex justify-content-center'>
                                    {!isHideInputBox && items.length !== 0 &&
                                        <div className="addPolygonTopicFieldSave ">
                                            <button
                                                disabled={disableControls}
                                                tabIndex={0}
                                                title="Remove"
                                                role="button"
                                                aria-label="Remove"
                                                className={`${disableControls ? 'disableIconsCross relatededitContentDelete' : 'relatededitContentDelete'}  
                                                ${tabId === "tab-entry" ? "AddEntryBtn" : "AddInputBtn"}`}
                                                onClick={() => {
													if (newItemDescription.trim() !== "") {setNewItemDescription("")}
                                                    setIsHideInputBox(true);
                                                }}
                                            ></button>
                                        </div>
                                    }
                                    <div className="addPolygonTopicFieldSave mt-2">
                                        <button
                                            disabled={disableControls}
                                            tabIndex={0}
                                            title="Add"
                                            role="button"
                                            aria-label="Add"
                                            className={`${disableControls ? 'disableIconsAdd relatedContentAdd' : 'relatedContentAdd'}  
                                            ${tabId === "tab-entry" ? "AddEntryBtn" : "AddInputBtn"}`}
                                            onClick={()=>{
												// handleAddItem()
												if(items.length===0)
												setIsHideInputBox(false)
											}}
                                        ></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    );
};


useEffect(() => {
	const entryItems = getFilteredItems('tab-entry');
	const inputItems = getFilteredItems('tab-input');
	if (entryItems.length===0) setIsHideInputBox(entryItems.length > 0);
	if (inputItems.length===0) setIsHideInputBox(inputItems.length > 0);
  }, [currentEntryTab, entryCriteriaWithSuggestions]);


return (
	
<>
<div className="topicDetailsCkEditor entryExitCriTab">
      <div className="criteria-tab-container">
        
        <ul className="entry-criteria-tabs" role="tablist">
          <li 
		  	className={currentEntryTab === 'tab-entry' ? 'currentEntry' : ''}
            onClick={() => {
				handleEntryTabClick('tab-entry') 
				if (getFilteredItems(currentEntryTab)?.length !== 0) { setIsHideInputBox(true); }}}
			>
				Entry Criteria 
			</li>
          <li
            className={currentEntryTab === 'tab-input' ? 'currentEntry' : ''} 
			onClick={() => {
				handleEntryTabClick('tab-input')
				if (getFilteredItems(currentEntryTab)?.length === 0) { setIsHideInputBox(false); }
			}}           
          >
            Input
          </li>
        </ul>
        {renderTabContent("tab-entry")}
        {renderTabContent("tab-input")}
      </div>
	{renderSuggestions()}
    {renderInputSuggestions()}
    </div>
    </>
	);
};

export default EntryCriteriaContribution;

